import { useNavigate } from 'react-router-dom'; // Importa o hook de navegação
import React, { useState, useEffect } from 'react'; 
import { Link } from 'react-router-dom'; 
import { useUser } from '../UserContext'; 
import '../Financeiro/index.css';

const Financeiro = () => {
  const [clientes, setClientes] = useState([]);
  const [clientes2, setClientes2] = useState([]);
  const [filteredClientes, setFilteredClientes] = useState([]); // Estado para clientes filtrados
  const [formStatus, setFormStatus] = useState({}); // Atualizar Status
  const [formDias, setFormDias] = useState({}); // Atualizar Data Liberado
  const { userInfo } = useUser();
  const [searchTerm, setSearchTerm] = useState(''); // Termo de busca
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false); // Controle para visibilidade da lista
  const navigate = useNavigate(); // Hook para redirecionamento

  useEffect(() => {
    // Redireciona para a home se userInfo não estiver disponível
    if (!userInfo || !userInfo.username) {
      navigate('/'); // Redireciona para a rota da página inicial
    }
  }, [userInfo, navigate]); // Executa o efeito sempre que userInfo ou navigate mudarem

  useEffect(() => {
    // Fetch para obter lista de clientes
    if (userInfo?.url) {
      fetch(userInfo.url + '/listaCliente')
        .then(response => response.json())
        .then(data => {
          setClientes(data);
          setFilteredClientes(data); // Inicializa os clientes filtrados
        })
        .catch(error => console.error('Erro ao buscar clientes:', error));

      fetch(userInfo.url + '/listaCliente2')
        .then(response => response.json())
        .then(data => setClientes2(data))
        .catch(error => console.error('Erro ao buscar clientes 2:', error));
    }
  }, [userInfo]); // Certifica-se de que o fetch ocorre apenas quando userInfo estiver disponível

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    // Filtra os clientes com base no termo digitado
    const filtered = clientes.filter(cliente =>
      cliente.NOME.toLowerCase().includes(term) || cliente.COL_FANTASIA.toLowerCase().includes(term)
    );

    setFilteredClientes(filtered);
  };

 /* const handleSelect = (cliente) => {
    setSelectedCliente(cliente);
    setSearchTerm(cliente.NOME); // Exibe o nome no campo
    setFormStatus({ cliente: cliente.ID }); // Atualiza o estado com o ID do cliente
    setShowSuggestions(false); // Oculta a lista após seleção
  };*/
  const handleSelect = (cliente) => {
    //console.log('Cliente selecionado:', cliente);
    setSelectedCliente(cliente); // Atualiza o cliente selecionado
    setFormStatus({ cliente: cliente.ID }); // Atualiza o estado com o ID do cliente
  };  

  const handleAtualizarStatus = (e) => {
    e.preventDefault();
    fetch(userInfo.url + '/AtualizarStatus', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao atualizar status.');
        return response.json();
      })
      .then(data => {
        alert('Atualização enviada com sucesso!');
        console.log(data);
      })
      .catch(error => {
        console.error('Erro:', error);
        alert('Houve um erro ao enviar a atualização.');
      });
  };

  const handleLiberarCliente = (e) => {
    e.preventDefault();
  
    // Certifique-se de que formStatus contém o clienteId antes de fazer o POST
    if (!formStatus.cliente) {
      alert("Por favor, selecione um cliente antes de continuar.");
      return;
    }
  
    fetch(userInfo.url + '/liberar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formStatus), // Envia o clienteId no corpo
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao liberar cliente.');
        return response.json();
      })
      .then(data => {
        alert('Cliente liberado com sucesso!');
        //console.log(data);
      })
      .catch(error => {
        //console.error('Erro:', error);
        alert('Houve um erro ao liberar cliente.');
      });
  };  

  const handleAtualizarDias = (e) => {
    e.preventDefault();
    fetch(userInfo.url + '/attDiaBloq', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formDias),
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao atualizar dias.');
        return response.json();
      })
      .then(data => {
        alert('Atualização de dias realizada com sucesso!');
        console.log(data);
      })
      .catch(error => {
        console.error('Erro:', error);
        alert('Houve um erro ao atualizar dias.');
      });
  };

  const handleEnviarMensagens = () => {
    fetch('https://n8n.dnsalias.com/webhook/36db31db-2441-48ff-ac22-2f0ab9a8940d', {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao enviar mensagem.');
        return response.json();
      })
      .then(data => {
        alert('Mensagem enviada com sucesso!');
        console.log(data);
      })
      .catch(error => {
        console.error('Erro:', error);
        alert('Houve um erro ao enviar mensagem.');
      });
  };

  return (
    <>
      <header className="header">
        <h2>Bem-vindo, {userInfo?.username || 'Usuário'}!</h2>
      </header>
  
      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      <form onSubmit={handleAtualizarStatus}>
        <h2>Atualizar Status</h2>
        <button type="submit">Atualizar Status</button>
      </form>
  
      <form onSubmit={handleLiberarCliente}>
        <h2>Liberação por Confiança</h2>
        <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto', position: 'relative' }}>
          <h2 style={{
            fontSize: '24px',
            color: '#3498db',
            textAlign: 'center',
            marginBottom: '15px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
          }}>
            Pesquisar Cliente
          </h2>

          {/* Campo de busca */}
          <input
            type="text"
            placeholder="Clique para digitar sua busca"
            value={searchTerm}
            onChange={handleSearch}
            onFocus={() => setShowSuggestions(true)} // Mostra a lista ao focar
            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)} // Oculta lista ao perder o foco (com delay)
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '8px',
              border: '1px solid #ccc',
            }}
          />

          {/* Exibe lista suspensa somente se showSuggestions for true */}
          {showSuggestions && filteredClientes.length > 0 && (
            <ul style={{
              listStyleType: 'none',
              padding: 0,
              margin: 0,
              maxHeight: '150px',
              overflowY: 'auto',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: 'white',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              position: 'absolute', // Faz a lista flutuar abaixo do input
              zIndex: 10, // Garante que a lista fique acima de outros elementos
              width: '100%',
            }}>
              {filteredClientes.map(cliente => (
                <li
                  key={cliente.ID}
                  value={cliente.ID}
                  onClick={() => handleSelect(cliente)}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f4f4f4'} // Destaque ao passar o mouse
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'} // Remove o destaque
                >
                  {cliente.NOME} - {cliente.COL_FANTASIA}
                </li>
              ))}
            </ul>
          )}

          {/* Exibe o cliente selecionado */}
          {selectedCliente && (
            <div style={{
              marginTop: '15px',
              fontSize: '16px',
              backgroundColor: '#f9f9f9',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}>
              <strong>Cliente Selecionado:</strong> {selectedCliente.NOME} - {selectedCliente.COL_FANTASIA}
            </div>
          )}
        </div>

        <button type="submit">Liberar Cliente</button>
      </form>
  
      <form onSubmit={handleAtualizarDias}>
        <h2>Atualização de Dias</h2>
        <select onChange={(e) => setFormDias({ ...formDias, cliente: e.target.value })}>
          <option value="">Selecione o cliente</option>
          {clientes2.map(cliente => (
            <option key={cliente.ID} value={cliente.ID}>
              {cliente.NOME} - {cliente.COL_FANTASIA}
            </option>
          ))}
        </select>
        <button type="submit">Atualizar Dias</button>
      </form>
  
      <div>
        <h2>Envio de Mensagens</h2>
        <button onClick={handleEnviarMensagens}>Enviar Mensagens</button>
      </div>
    </>
  );  
};

export default Financeiro;